// Module
var code = "<typical-week ref=\"typicalWeek\"></typical-week>\n<calendar-exception ref=\"calendarException\"></calendar-exception>";
// Exports
module.exports = code;